"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useChatMessages = void 0;
var react_1 = __importDefault(require("react"));
var use_chat_driver_1 = require("./use-chat-driver");
/**
 * useChatMessages() must be used within a ChatDriverProvider
 */
function useChatMessages(search) {
    var chatDriver = react_1["default"].useContext(use_chat_driver_1.ChatDriverContext);
    if (chatDriver == null) {
        throw new Error('ChatDriverContext not found');
    }
    var messages = (0, use_chat_driver_1.useEmittedDataSource)(function (chatDriver) { return chatDriver.groupedMessages; }, "changed/groupedMessages", chatDriver);
    var _a = react_1["default"].useState(null), searchResults = _a[0], setSearchResults = _a[1];
    react_1["default"].useEffect(function () {
        if (search) {
            setSearchResults(Object.values(chatDriver.rawMessages).filter(function (m) { var _a; return m.content.encrypted !== true && ((_a = m.content.text) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(search.toLowerCase())); }).map(function (m) { return ({
                message: m,
                showHeader: true,
                showUnreadIndicator: false
            }); }));
        }
        else {
            setSearchResults(null);
        }
    }, [search]);
    return {
        messages: searchResults !== null && searchResults !== void 0 ? searchResults : messages,
        isRefreshing: false,
        loadOlder: chatDriver.loadOlder
    };
}
exports.useChatMessages = useChatMessages;
